import CityPageTemplate from "../city-template/CityPageTemplate";
import { mishawakaConfig } from "./data";

export default function MishawakaPage() {
  return <CityPageTemplate config={mishawakaConfig} />;
}